var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "modal fade",
      attrs: { id: "shipping-info-modal", role: "dialog" },
      on: {
        click: function($event) {
          _vm.$emit("close")
        }
      }
    },
    [
      _c(
        "div",
        {
          staticClass: "modal-dialog modal-lg",
          on: {
            click: function($event) {
              $event.stopPropagation()
            }
          }
        },
        [
          _c(
            "div",
            { staticClass: "modal-content additonal-modal-content bd-rds-16" },
            [
              _c("div", { staticClass: "pd-t-20 pd-b-20 pd-l-20 pd-r-20" }, [
                _c("p", { staticClass: "text-size-20 font-bold" }, [
                  _vm._v("出荷情報")
                ]),
                _vm._v(" "),
                _c("dl", [
                  _c("dt", [_vm._v("配送業者")]),
                  _vm._v(" "),
                  _c(
                    "dd",
                    {
                      class: [
                        { "no-data": !_vm.selectShipping.shippingMethodName }
                      ]
                    },
                    [
                      _vm._v(
                        _vm._s(
                          _vm.selectShipping.shippingMethodName ||
                            "（商品の出荷後に表示）"
                        )
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c("dt", [_vm._v("お問い合わせ番号")]),
                  _vm._v(" "),
                  _c(
                    "dd",
                    {
                      staticClass: "flexbox mr-b-30",
                      class: [{ "no-data": !_vm.selectShipping.trackingCode }]
                    },
                    [
                      _vm._v(
                        "\n            " +
                          _vm._s(
                            _vm.selectShipping.trackingCode ||
                              "（商品の出荷後に表示）"
                          ) +
                          "\n            "
                      ),
                      _vm.selectShipping.trackingCode
                        ? _c(
                            "button",
                            {
                              staticClass: "product-bubble-wrapper",
                              attrs: { type: "button" },
                              on: {
                                click: function($event) {
                                  _vm.handleClickCoppy(
                                    _vm.selectShipping.trackingCode
                                  )
                                }
                              }
                            },
                            [
                              _c("i", {
                                staticClass: "fa fa-clipboard",
                                attrs: {
                                  "aria-hidden": "true",
                                  "data-toggle": "tooltip"
                                }
                              }),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: _vm.isShowBubble,
                                      expression: "isShowBubble"
                                    }
                                  ],
                                  staticClass: "product-bubble bubble"
                                },
                                [
                                  _vm._v(
                                    "\n                コピーしました\n              "
                                  )
                                ]
                              )
                            ]
                          )
                        : _vm._e()
                    ]
                  ),
                  _vm._v(" "),
                  _c("dt", [_vm._v("お届け先名")]),
                  _vm._v(" "),
                  _c(
                    "dd",
                    { class: [{ "no-data": !_vm.selectShipping.toName }] },
                    [
                      _vm._v(
                        _vm._s(_vm.selectShipping.toName || "（確定後に表示）")
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c("dt", [_vm._v("郵便番号")]),
                  _vm._v(" "),
                  _c(
                    "dd",
                    {
                      class: [{ "no-data": !_vm.selectShipping.toPostalCode }]
                    },
                    [
                      _vm._v(
                        _vm._s(
                          _vm.selectShipping.toPostalCode || "（確定後に表示）"
                        )
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c("dt", [_vm._v("住所")]),
                  _vm._v(" "),
                  _c(
                    "dd",
                    { class: [{ "no-data": !_vm.selectShipping.toAddress1 }] },
                    [
                      _vm._v(
                        _vm._s(
                          _vm.selectShipping.toAddress1 || "（確定後に表示）"
                        ) +
                          " " +
                          _vm._s(_vm.selectShipping.toAddress2 || "")
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c("dt", [_vm._v("電話番号")]),
                  _vm._v(" "),
                  _c(
                    "dd",
                    { class: [{ "no-data": !_vm.selectShipping.toPhoneNo }] },
                    [
                      _vm._v(
                        _vm._s(
                          _vm.selectShipping.toPhoneNo || "（確定後に表示）"
                        )
                      )
                    ]
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "text-center" }, [
                  _c(
                    "button",
                    {
                      staticClass: "btn text-size-14",
                      attrs: { type: "button" },
                      on: {
                        click: function($event) {
                          _vm.$emit("close")
                        }
                      }
                    },
                    [_vm._v("閉じる")]
                  )
                ])
              ])
            ]
          )
        ]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1f897ca6", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1f897ca6","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/view/warehouseAcross/components/ShippingInfoModal.vue
// module id = null
// module chunks = 